import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DirectLoggerFactory_instance3eeeymfa0ox12 as DirectLoggerFactory_instance } from './DirectLoggerFactory.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Level_INFO_getInstance1ztv8i0iil2fd as Level_INFO_getInstance } from './Level.mjs';
import { DefaultMessageFormatter17x784jf2u2xo as DefaultMessageFormatter } from './Formatter.mjs';
import { ConsoleOutputAppender373h7g73cvnnw as ConsoleOutputAppender } from './ConsoleOutputAppender.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function internalCheckFactory(name, loggerFactory) {
  if (!equals(loggerFactory, DirectLoggerFactory_instance)) {
    println("kotlin-logging: [WARN] configuring 'direct." + name + "' but the active logger factory is not 'DirectLoggerFactory' (active: " + getKClassFromExpression(loggerFactory).j1() + '). This config might be ignored.');
  }
}
var KotlinLoggingConfiguration$direct$1Class;
function KotlinLoggingConfiguration$direct$1() {
  if (KotlinLoggingConfiguration$direct$1Class === VOID) {
    class $ {
      constructor() {
        this.l2g_1 = Level_INFO_getInstance();
        this.m2g_1 = new (DefaultMessageFormatter())(true);
        this.n2g_1 = new (ConsoleOutputAppender())();
      }
      o2g(value) {
        this.l2g_1 = value;
        internalCheckFactory('logLevel', KotlinLoggingConfiguration_getInstance().b2f_1);
      }
      g2g() {
        return this.l2g_1;
      }
      p2g(value) {
        this.m2g_1 = value;
        internalCheckFactory('formatter', KotlinLoggingConfiguration_getInstance().b2f_1);
      }
      c2f() {
        return this.m2g_1;
      }
      i2g() {
        return this.n2g_1;
      }
    }
    initMetadataForClass($);
    KotlinLoggingConfiguration$direct$1Class = $;
  }
  return KotlinLoggingConfiguration$direct$1Class;
}
var KotlinLoggingConfigurationClass;
function KotlinLoggingConfiguration() {
  if (KotlinLoggingConfigurationClass === VOID) {
    class $ {
      constructor() {
        KotlinLoggingConfiguration_instance = this;
        this.z2e_1 = resolveStartupMessageDefault();
        var tmp = this;
        tmp.a2f_1 = new (KotlinLoggingConfiguration$direct$1())();
        this.b2f_1 = DirectLoggerFactory_instance;
      }
    }
    initMetadataForObject($, 'KotlinLoggingConfiguration');
    KotlinLoggingConfigurationClass = $;
  }
  return KotlinLoggingConfigurationClass;
}
var KotlinLoggingConfiguration_instance;
function KotlinLoggingConfiguration_getInstance() {
  if (KotlinLoggingConfiguration_instance === VOID)
    new (KotlinLoggingConfiguration())();
  return KotlinLoggingConfiguration_instance;
}
function resolveStartupMessageDefault() {
  try {
    var tmp = typeof window !== 'undefined' && (window.KOTLIN_LOGGING_STARTUP_MESSAGE === 'false' || window.KOTLIN_LOGGING_STARTUP_MESSAGE === false);
    var disabledInWindow = (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
    if (disabledInWindow) {
      return false;
    }
    var tmp_0 = typeof process !== 'undefined' && process.env && (process.env.KOTLIN_LOGGING_STARTUP_MESSAGE === 'false' || process.env.KOTLIN_LOGGING_STARTUP_MESSAGE === false);
    var disabledInEnv = (!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : THROW_CCE();
    if (disabledInEnv) {
      return false;
    }
    return true;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      return true;
    } else {
      throw $p;
    }
  }
}
//region block: exports
export {
  KotlinLoggingConfiguration_getInstance as KotlinLoggingConfiguration_getInstance2gskotrxa3wxw,
};
//endregion

//# sourceMappingURL=KotlinLoggingConfiguration.mjs.map
